import { render } from "./PluginTabs.vue?vue&type=template&id=73f4b2c2"
import script from "./PluginTabs.vue?vue&type=script&lang=js"
export * from "./PluginTabs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Раиль\\Desktop\\Projects\\Mercury\\ametist.plugin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__